import PromotionalBanner from './PromotionalBanner'

export default PromotionalBanner
